// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"a5bc2f69","453":"54292a4b","879":"47d66b1f"}[chunkId] + ".chunk.js";
};